<template>
    <div class="login-container">
        <img src="static/images/bg.jpg" class="bg">
        
        <el-form :model="user" status-icon ref="user" label-position="left" label-width="0px" class="login-page">
            <div class="login-title"><i slot="prefix" class="el-icon-s-custom" style="font-size:30px; margin-right:10px"></i>用户注册</div>
            <el-form-item>
                <el-input ref="inputCompanyName" v-model="user.companyname" auto-complete="off" placeholder="请输入单位或个人名称">
                    <i slot="prefix" class="el-icon-office-building"></i>
                </el-input>
            </el-form-item>
            
            <el-form-item>
                <el-input ref="inputMan" v-model="user.man" auto-complete="off" placeholder="请输入联系人">
                    <i slot="prefix" class="el-icon-user"></i>
                </el-input>
            </el-form-item>
            
            <el-form-item>
                <el-input ref="inputPhone" v-model="user.phone" auto-complete="off" placeholder="请输入手机号码">
                    <i slot="prefix" class="el-icon-phone-outline"></i>
                </el-input>
            </el-form-item>
            
            <el-form-item>
                <el-link :underline="false" type="primary" style="color:#2f54eb" @click="doLogin()">返回登陆</el-link>
                <el-link :underline="false" type="primary" style="color:#2f54eb; float:right" href="http://www.fkerp.com" target="_bank">官方网站</el-link>
                <el-link :underline="false" type="primary" icon="el-icon-headset" style="color:#2f54eb; float:right; margin-right:20px"
                    href="tencent://message/?uin=2455247199&Site=qq&Menu=yes" target="_bank">在线顾问</el-link>
                <div>
                    <el-checkbox v-model="ifCheck">我已阅读并同意</el-checkbox>
                    <el-link :underline="false" type="primary" style="color:#2f54eb" @click="selectRegNote=true">《服务协议》</el-link>
                </div>
            </el-form-item>
            <el-button type="primary" class="my-button-primary" style="font-size:16px; height:45px; width:100%; border-radius:100px" @click="register" :loading="logining">立即注册
            </el-button>
        </el-form>
        
        <el-dialog :destroy-on-close="true" :close-on-click-modal="true" title="服务协议" :visible.sync="selectRegNote" :width="'1024px'">
            <regNote v-if="selectRegNote"></regNote>
        </el-dialog>
    </div>
</template>

<script>
import common from '../../utils/common';
import regNote from './regNote.vue';

export default {
    components: { regNote },
    data() {
        return {
            logining: false,
            ifCheck: false,
            selectRegNote: false,
            user: {
                companyname: "",
                man: "",
                phone: "",
            }
        }
    },
    
    mounted() {
        let self = this;
        document.onkeydown = function (e) {
            let key = window.event.keyCode
            if (key === 13) {
                self.register();
            }
        }
    },
    
    methods: {
        doLogin() {
            this.$router.push({ path: "/login" });
        },
        
        canSave() {
            if (common.toStrAndTrim(this.user.companyname) === '') {
                common.msgError('请输入单位或个人名称');
                this.$refs.inputCompanyName.focus();
                return false;
            }
            
            if (common.toStrAndTrim(this.user.man) === '') {
                common.msgError('请输入联系人');
                this.$refs.inputMan.focus();
                return false;
            }
            
            if (common.toStrAndTrim(this.user.phone) === '') {
                common.msgError('请输入手机号码');
                this.$refs.inputPhone.focus();
                return false;
            }
            
            if (!(/^1[34578]\d{9}$/.test(this.user.phone)))
            {
                common.msgError('请正确输入手机号码');
                this.$refs.inputPhone.focus();
                return false;
            }
            
            if (!this.ifCheck) {
                common.msgError('须阅读并同意《服务协议》完成注册！');
                return false;
            }
            return true;
        },
        
        async register() {
            try {
                if (!this.canSave()) return false;
                
                this.logining = true;
                const res = await this.$axios.post(common.serverApi('register'), this.user);
                if (res.data.code === 1000) {
                    await common.msgPopInfo('恭喜您, 注册成功!');
                    this.$router.push({ path: "/login", query: { companyname: this.user.companyname, username: 'admin', password: '123' } });
                }
                
                else {
                    common.msgPopInfo(res.data.message);
                    return false;
                }
            }
            catch (err) {
                console.log(err);
                common.msgError('注册异常')
                return false;
            }
            finally {
                this.logining = false;
            }
        }
    }
};

</script>



// WEBPACK FOOTER //
// src/components/user/register.vue